import { render } from "./CustomButton.vue?vue&type=template&id=a72d1716&scoped=true"
import script from "./CustomButton.vue?vue&type=script&lang=js"
export * from "./CustomButton.vue?vue&type=script&lang=js"

import "./CustomButton.vue?vue&type=style&index=0&id=a72d1716&scoped=true&lang=css"

import exportComponent from "/var/www/app/app-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72d1716"]])

export default __exports__